<template>
    <form
        ref="form"
        action="/coupons"
        method="POST"
        @submit.prevent="onSubmit(form)"
    >
        <div
            class="mt-4 bg-white px-2 py-5 px-4 sm:rounded-lg sm:shadow-md sm:border sm:border-gray-200 sm:p-6"
        >
            <input type="hidden" name="_token" :value="csrf" />
            <input type="hidden" name="coupon_code" :value="couponCode" />

            <div>
                <label
                    for="email"
                    class="block text-sm font-medium text-gray-700"
                >
                    Send To Email(s)
                </label>
                <div class="mt-1 relative rounded-md shadow-sm">
                    <input
                        v-model="inputs.email"
                        :ref="refs.email"
                        id="email"
                        name="email"
                        type="text"
                        required
                        :class="[
                            hasError(errors, 'email')
                                ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 pr-10'
                                : 'focus:ring-nutreance-green focus:border-nutreance-green',
                            'appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none sm:text-sm',
                        ]"
                        :aria-invalid="
                            hasError(errors, 'email') ? 'true' : 'false'
                        "
                        :aria-describedby="
                            hasError(errors, 'email') ? 'email-error' : ''
                        "
                    />
                    <div
                        v-if="hasError(errors, 'email')"
                        class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                    >
                        <ExclamationCircleIcon
                            class="h-5 w-5 text-red-500"
                            aria-hidden="true"
                        />
                    </div>
                </div>
                <p
                    v-if="hasError(errors, 'email')"
                    class="mt-2 text-sm text-red-600"
                    id="email-error"
                >
                    {{ error(errors, "email") }}
                </p>
            </div>

            <div class="mt-6">
                <label
                    for="message"
                    class="block text-sm font-medium text-gray-700"
                >
                    Your Message
                </label>
                <div class="mt-1 relative rounded-md shadow-sm">
                    <textarea
                        v-model="inputs.message"
                        :ref="refs.message"
                        id="message"
                        name="message"
                        rows="5"
                        required
                        :class="[
                            hasError(errors, 'message')
                                ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 pr-10'
                                : 'focus:ring-nutreance-green focus:border-nutreance-green',
                            'appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none sm:text-sm',
                        ]"
                        :aria-invalid="
                            hasError(errors, 'message') ? 'true' : 'false'
                        "
                        :aria-describedby="
                            hasError(errors, 'message') ? 'message-error' : ''
                        "
                    />
                    <div
                        v-if="hasError(errors, 'message')"
                        class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                    >
                        <ExclamationCircleIcon
                            class="h-5 w-5 text-red-500"
                            aria-hidden="true"
                        />
                    </div>
                </div>
                <p
                    v-if="hasError(errors, 'message')"
                    class="mt-2 text-sm text-red-600"
                    id="message-error"
                >
                    {{ error(errors, "message") }}
                </p>
            </div>
        </div>

        <div class="sm:px-6 py-6">
            <button
                name="send"
                type="submit"
                class="inline-flex justify-center items-center px-6 py-3 border border-transparent rounded-md shadow-sm font-medium text-white bg-nutreance-green hover:bg-nutreance-green-darker focus:outline-none w-full"
            >
                <LoadingIcon v-if="submitted" class="h-5 w-5 mr-2" />
                <PaperAirplaneIcon
                    v-else
                    class="h-5 w-5 mr-2"
                    aria-hidden="true"
                />
                Send
            </button>
        </div>
    </form>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref } from "vue";
import { ExclamationCircleIcon, PaperAirplaneIcon } from "@heroicons/vue/solid";
import { useForm } from "../../functions/useForm";
import LoadingIcon from "../LoadingIcon.vue";

const props = defineProps<{
    couponCode?: string;
    csrf?: string;
    errors?: any;
    old?: any;
}>();

const { error, hasError, oldInput, onSubmit, submitted } = useForm();
const form = ref<any>(null);
const refs = {
    email: ref<any>(null),
    message: ref<any>(null),
};
const inputs = reactive({
    email: oldInput(props.old, "email") ? oldInput(props.old, "email") : null,
    message: oldInput(props.old, "message")
        ? oldInput(props.old, "message")
        : "Check out nutreance.com. They offer a personalized health profile with specific insights and recommendations on the best supplements for you. Here's 10% off your first order of $35 or more.",
});

onMounted(() => {
    switch (true) {
        case !!hasError(props.errors, "email"):
            return refs.email.value.focus();
        case !!hasError(props.errors, "message"):
            return refs.message.value.focus();
        default:
            return refs.email.value.focus();
    }
});
</script>
